/** Error del envelope `{ error: { code, message, details } }` (catálogo en la API: docs/error-codes.md). */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details: Record<string, unknown> = {},
    readonly requestId?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export const SESSION_ENDED = new Set([
  'SESSION_REVOKED',
  'SESSION_EXPIRED',
  'REFRESH_INVALID',
  'TOKEN_INVALID',
  'UNAUTHORIZED',
]);

export function mensajeDe(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  return 'No pudimos conectar con la API de Consalud. Revisa tu conexión e inténtalo de nuevo.';
}
